import script from "./label-title-wrap.vue?vue&type=script&lang=ts&setup=true"
export * from "./label-title-wrap.vue?vue&type=script&lang=ts&setup=true"

import "./label-title-wrap.vue?vue&type=style&index=0&id=15daf722&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15daf722"]])

export default __exports__